<template>
    <div class="parametric-flats">
        <ParametricFlat v-for="flat in flats"
                        :key="flat.id"
                        :flat-data="flat"
                        :is-mobile="isMobile" />
    </div>
</template>

<script>
import ParametricFlat from '@/blocks/ParametricBlock/ParametricFlat/ParametricFlat';

/**
 * Компонент для вывода помещений
 */
export default {
    name: 'ParametricFlats',

    components: {
        ParametricFlat
    },

    props: {
        /**
         * Массив помещений
         */
        flats: {
            type: Array,
            default() {
                return [];
            }
        },
        isMobile: Boolean
    }
};
</script>

<style lang="scss">
@import "ParametricFlats";
</style>
